import { getColor } from "@/utils/theme/colors";
import CrossIcon from '@/assets/cross-icon.svg'
import FlexBox from "@/atomic-components/FlexBox";
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getStyle } from "@/utils/theme/fonts";

function SelectedFilterTile(props:any) {

    return ( 
        <FlexBox sx={{padding:'14px 26px',background:getColor('Minty -5'),alignItems:'center',borderRadius:'24px',margin:'0 8px' }} onClick={()=>{
            props.onFilterChange(props.data.key,props.data.val)
        }}>
            <CrossIcon />
            <LencoTypography sx={{...getStyle('Small_Regular'),color:getColor('Gray -1'),marginLeft:'4px'}}>{props.data.val}</LencoTypography>
        </FlexBox>
     );
}

export default SelectedFilterTile;